import { useFela } from 'react-fela';

import { useSecretFormHasPasskey } from '@/modules/secrets/hooks/useSecretFormHasPasskey';
import { Text } from '@/modules/ui';

import { useGroupsWithLocalizedAllUsersGroup } from '../../hooks';
import type { GroupWithPermissions } from '../../types';
import { GroupItem, type GroupItemProps } from '../GroupItem';
import * as felaRules from '../Groups/Groups.rules';

export interface FormFieldGroupsProps extends Pick<GroupItemProps, 'onRemove' | 'onUpdate'> {
    value: GroupWithPermissions[];
}

export const FormFieldGroups = ({ value, onRemove, onUpdate }: FormFieldGroupsProps) => {
    const groups = useGroupsWithLocalizedAllUsersGroup(value);

    const { css } = useFela({
        removable: true,
    });

    const hasPasskey = useSecretFormHasPasskey();

    if (!groups.length) {
        return null;
    }

    return (
        <div className={css(felaRules.container)}>
            <Text variant='ParagraphSmallMedium' elementType='ul' customStyle={felaRules.list}>
                {groups.map(group => (
                    <GroupItem key={group.id} {...group} editable onRemove={onRemove} onUpdate={onUpdate} hasPasskey={hasPasskey} />
                ))}
            </Text>
        </div>
    );
};
